import { render, staticRenderFns } from "./ProfilePaymentSystem.vue?vue&type=template&id=2001bcbe&scoped=true&"
import script from "./ProfilePaymentSystem.vue?vue&type=script&lang=ts&"
export * from "./ProfilePaymentSystem.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePaymentSystem.vue?vue&type=style&index=0&id=2001bcbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001bcbe",
  null
  
)

export default component.exports